import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bt4s5wuad9: FaireBrandEntity = {
  token: "b_bt4s5wuad9",
  type: "brand",
  name: "Sparkle Sisters by Couture Clips",
  avatarUrl:
    "https://cdn.faire.com/fastly/5ae5d6c01f7e58af63a9692c334dfad4caebf24d54c403c4500b08f5295983c9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/11ea821f59c909d07521c633c08d795a4fb1255470a9e8045019678cf4832004.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5ae5d6c01f7e58af63a9692c334dfad4caebf24d54c403c4500b08f5295983c9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/11ea821f59c909d07521c633c08d795a4fb1255470a9e8045019678cf4832004.jpeg",
  location: "Montclair, NJ, USA",
  minimumOrderDollars: 75,
  rating: 4.7,
  reviewCount: 364,
  isInsider: true,
  description:
    "Inspired by the birth of her two daughters and her love for styling the girls’ hair with beautiful accessories, Lisa created Sparkle Sisters by Couture Clips in 2010. Applying her unique sense of style and creative design, Lisa initially launched the brand to focus solely on children’s hair accessories. After establishing the brand in the hair accessory space, Lisa has since extended the Sparkle Sisters creative signature into new children’s fashion product categories, so parents can dress their girls in a range of stylish combinations from the brand.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:28.292Z",
    importedBy: "entity-db-cli",
  },
};
